
import React, { createContext, useContext, useEffect, useRef, useState } from 'react';

const MODEL_LOADING = 'MODEL_LOADING';
const MODEL_READY = 'MODEL_READY';
const ERROR = 'ERROR';

const DetectionWorkerContext = createContext();

export const useDetectionWorker = () => {
  return useContext(DetectionWorkerContext);
};

export const DetectionWorkerProvider = ({ enabled = false, children }) => {
  const workerRef = useRef(null);
  const [workerStatus, setWorkerStatus] = useState('idle'); 
  const [loadingMessage, setLoadingMessage] = useState('');

  useEffect(() => {
    if (!enabled) {
      if (workerRef.current) {
        console.log("OCR disabled — terminating Web Worker...");
        workerRef.current.terminate();
        workerRef.current = null;
        setWorkerStatus('idle');
        setLoadingMessage('');
      }
      return;
    }

    if (!workerRef.current) {
      console.log("Initializing Web Worker...");
      setWorkerStatus('loading');
      
      const worker = new Worker(new URL('./detection.worker.js', import.meta.url), { type: 'module' });
      workerRef.current = worker;

      worker.onmessage = (event) => {
        const { type, payload } = event.data;
        switch (type) {
          case MODEL_LOADING:
            console.log("Worker message: MODEL_LOADING -", payload);
            setLoadingMessage(payload);
            break;
          case MODEL_READY:
            console.log("Worker message: MODEL_READY");
            setWorkerStatus('ready');
            setLoadingMessage('');
            
            worker.onmessage = null; 
            break;
          case ERROR:
            console.error("Worker initialization error:", payload);
            setWorkerStatus('error');
            break;
          default:
            break;
        }
      };
      
      worker.postMessage({ type: 'INIT' });
    }

    return () => {
      if (workerRef.current) {
        console.log("Terminating Web Worker...");
        workerRef.current.terminate();
        workerRef.current = null;
      }
    };
  }, [enabled]); 

  const value = {
    worker: workerRef.current,
    workerStatus,
    loadingMessage
  };

  return (
    <DetectionWorkerContext.Provider value={value}>
      {children}
    </DetectionWorkerContext.Provider>
  );
};